<template>
  <div id="list-dnt">
    <template class="bg-success">
      <div class="d-flex mb-3" v-if="view === 'entrada'">
        <b-button
          variant="outline-primary"
          size="sm"
          data-cy="sign-documents"
          @click="searchMassiveSign()"
        >
          Quiero firmar varios documentos
        </b-button>
        <div class="d-flex justify-content-between ml-3">
          <div v-if="showCheck && orderTrays.length">
            <b-form-checkbox
              class="d-inline-block"
              v-model="selectAll"
              data-cy="select-all"
              @change="selectAllFlows()"
            >
            </b-form-checkbox>
            Seleccionar todos
          </div>
          <b-button
            variant="primary"
            size="sm"
            class="ml-3"
            data-cy="sign-all-flows"
            v-if="selectedFlows.length && filteredUserSigns.length"
            @click="signAllFlows()"
          >
            Firmar
          </b-button>
          <b-button
            variant="warning"
            size="sm"
            class="ml-3"
            data-cy="cant-sign"
            v-if="selectedFlows.length && !filteredUserSigns.length"
          >
            Firmas habilitadas no soportan esta acción
          </b-button>
        </div>
      </div>
    </template>
    <div class="d-flex search-bar mb-2" v-if="view === 'general'">
      <vs-input
        icon-after="true"
        class="mt-2 w-100"
        size="small"
        label-placeholder="icon-after"
        icon="mode_edit"
        placeholder="Buscar coincidencias"
        v-model="textSearch"
        v-on:keyup.enter="fetchDocuments()"
        data-cy="search"
      />
      <vs-button
        v-if="searchParam"
        radius
        class="ml-3"
        color="primary"
        type="border"
        icon="highlight_off"
        size="small"
        @click="clearSearch()"
      />
    </div>
    <TraysFilters
      :value="filters"
      :onChange="onChangeFilters"
      :clear="clearFilters"
    />
    <hr>
    <FilesHeader />
    <div class="force-render" :key="forceRender">
      <FileRow
        :key="file.aprobacionId"
        v-for="file in orderTrays"
        :file="file"
        process="sign"
        :show-check="showCheck"
        :blockedProcess="blockedProcess"
        @select-flow="selectFlow"
        @unselect-flow="unSelectFlow"
        :select-file="selectFile"
        data-cy="file"
      />
    </div>
    <FilesPagination
      :show="trays.length"
      v-model="page"
    />
    <b-modal
      title="Firmar documentos"
      ref="process"
      hide-footer
      no-close-on-backdrop
    >
      <ModalSignProcess
        :selected-flows="selectedFlows"
        process="sign"
        @close-modal="closeModal"
      />
    </b-modal>
  </div>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

import FilesHeader from '@/febos/chile/approvals/components/trays/FilesHeader';
import FileRow from '@/febos/chile/approvals/components/trays/FileRow';
import TraysFilters from '@/febos/chile/approvals/components/trays/TraysFilters';
import FilesPagination from '@/febos/chile/approvals/components/trays/FilesPagination';
import { removeSearchParams, updateSearchParams } from '@/febos/global/utils/router';
import { mergeFilters } from '@/febos/chile/dnt/utils/fitlers';
import ModalSignProcess from '@/febos/chile/approvals/components/massiveProcess/ModalSignProcess';
import { signerProviderConfigs } from '@/febos/chile/approvals/components/trays/managementTray/constants';

export default {
  name: 'Trays',
  components: {
    ModalSignProcess,
    FilesPagination,
    TraysFilters,
    FileRow,
    FilesHeader
  },
  mixin: [],
  data() {
    return {
      searchParam: false,
      textSearch: '',
      selectedFile: {},
      filters: '',
      view: this.$route.params.view,
      page: Number.parseInt(this.$route.query.page || 1, 10),
      paginate: Number.parseInt(this.$route.query.paginate || 20, 10),
      forceRender: Date.now(),
      selectedFlows: [],
      showCheck: false,
      selectAll: false,
      blockedProcess: JSON.parse(localStorage.getItem('aprobacion_masiva_bloqueada')) || [],
      signerProviderConfigs,
    };
  },
  watch: {
    trays() {
      this.forceRender = Date.now(); // TODO: remove this.
    },
    async page(page) {
      updateSearchParams({ page });
      await this.fetchTrays();
    },
    loading(value) {
      if (!value) {
        this.$vs.loading.close('#list-dnt > .con-vs-loading');
        return;
      }

      this.$vs.loading({
        container: '#list-dnt',
        scale: 0.6
      });
    },
    error(error) {
      if (error !== '') {
        this.$vs.notify({
          title: 'Oops!',
          text: error,
          color: 'danger',
          time: 10000,
          position: 'top-center'
        });
        this.clearErrorMessage();
      }
    }
  },
  computed: {
    ...mapGetters('Approvals', [
      'loading',
      'error',
      'trays'
    ]),
    ...mapGetters('Empresas', [
      'company',
      'userSignConfiguration'
    ]),
    ...mapGetters('Usuario', [
      'currentUser'
    ]),
    filteredUserSigns() {
      return this.userSignConfiguration.userSigns.filter((firma) => firma.proveedor
        !== signerProviderConfigs.ASignAPI.key
        || (firma.proveedor === signerProviderConfigs.ASignAPI.key && !firma.atendida));
    },
    orderTrays() {
      if (this.view === 'pre-oficina' && this.trays.length) {
        return [...this.trays]
          .sort((a, b) => (a.aprobacionesPasoEstadoId.toString())
            .localeCompare((b.aprobacionesPasoEstadoId.toString())));
      }
      return this.trays;
    }
  },
  methods: {
    ...mapActions('Approvals', [
      'listTrays',
      'searchInTrays',
      'clearErrorMessage',
      'markFlows',
      'markFlow',
      'selectFileState',
      'downloadTrays',
      'fetchDocumentTypeReferences'
    ]),
    ...mapActions('Modals', [
      'closeModal'
    ]),
    ...mapActions('Empresas', [
      'getUserSigns'
    ]),
    async clearSearch() {
      this.searchParam = false;
      this.textSearch = '';
      this.fetchDocuments();
    },
    closeModal() {
      if (this.$refs.process) {
        this.$refs.process.hide();
        this.$bvToast.toast(
          '¡Operación efectuada correctamente! Se te avisará por correo cuando termine el proceso completo.',
          {
            title: '¡Genial!',
            variant: 'primary',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 8000
          }
        );
      }
      this.selectedFlows = [];
      this.fetchTrays();
      this.markFlows(false);
    },
    signAllFlows() {
      this.$refs.process.show();
    },
    selectAllFlows() {
      if (this.selectAll) {
        this.selectedFlows = this.trays;
      } else {
        this.selectedFlows = [];
      }
      this.markFlows(this.selectAll);
    },
    selectFlow(file) {
      this.selectedFlows.push(file);
      this.markFlow({ id: file.idAprobacion, selected: true });
    },
    unSelectFlow(file) {
      this.selectedFlows = this.selectedFlows
        .filter((flow) => (flow.idAprobacion !== file.idAprobacion));
      this.markFlow({ id: file.idAprobacion, selected: false });
    },
    selectFile(file) {
      this.selectedFile = file;
      this.selectFileState(file.idAprobacion);
    },
    fetchTrays() {
      const query = {
        filtros: mergeFilters(this.filters, this.$route.query.filters),
        pagina: this.page,
        orden: '-fechaCreacion',
        elementosPorPagina: this.paginate
      };
      this.listTrays(query);
    },
    async fetchDocuments() {
      this.loadingFiles = true;
      const filtroContent = this.textSearch !== '' ? `content$${ this.textSearch}` : '';
      const query = {
        params: {
          pagina: this.page,
          orden: '-fechaCreacion',
          elementosPorPagina: this.paginate,
          filtros: mergeFilters(this.$route.query.filters) !== ''
            ? `${mergeFilters(this.$route.query.filters) }|${ filtroContent}` : filtroContent
        }
      };
      await this.searchInTrays(query);
      this.loadingFiles = false;
    },
    async onChangeFilters(filters, onMounted) {
      this.filters = filters;
      if (!onMounted) {
        if (this.page !== 1) {
          this.page = 1;
          // using else because this method has two responsibilities
        } else {
          // force fetch (if we change the page from 1 to 1 the watcher not run)
          await this.fetchTrays();
          this.selectAll = false;
          this.showCheck = false;
          await this.selectAllFlows();
        }
      }
    },
    clearFilters() {
      removeSearchParams(['filters']);
      // TODO: try to change to default filter state for current view.
      updateSearchParams({ page: 1 });
      this.$router.go();
    },
    async searchMassiveSign() {
      const query = {
        filtros: mergeFilters(this.filters, this.$route.query.filters).concat('|firmaPosicionada:Y'),
        pagina: this.page,
        orden: '-fechaCreacion',
        elementosPorPagina: this.paginate
      };
      await this.listTrays(query);
      this.showCheck = true;
    },
    async downloadData() {
      const query = {
        filtros: mergeFilters(this.filters, this.$route.query.filters),
        pagina: this.page,
        orden: '-fechaCreacion',
        elementosPorPagina: this.paginate,
        csv: 'si'
      };
      const res = await this.downloadTrays(query);
      const csvUrl = res.url.startsWith('http') ? res.url : `https://${res.url}`;
      const link = document.createElement('a');
      link.href = csvUrl;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  },
  created() {
    if (this.$refs.process) {
      this.$refs.process.hide();
    }
    this.selectedFlows = [];
    this.getUserSigns(this.company.iut);
    this.selectFileState('');
    this.fetchDocumentTypeReferences();
  },
  mounted() {
    this.fetchTrays();
  }
};
</script>
